// Threshold to suppress auto-labels near edges, preventing overlap
const LABEL_EDGE_THRESHOLD = 0.12;

/**
 * Creates an axis range styled to match the native grid template.
 * @param {Object} yAxis - amCharts ValueAxis instance
 * @param {number} value - Target axis level
 * @returns {Object} Configured amCharts AxisDataItem
 */
function createBoundaryRange(yAxis, value) {
  const range = yAxis.axisRanges.create();
  range.value = value;

  range.label.text = String(value);

  // Sync grid styles with the axis template
  const gridTpl = yAxis.renderer.grid.template;
  if (gridTpl.stroke) {
    range.grid.stroke = gridTpl.stroke;
  }
  range.grid.strokeOpacity = gridTpl.strokeOpacity;
  range.grid.strokeWidth = gridTpl.strokeWidth;

  // Sync label styles with the axis template
  const labelTpl = yAxis.renderer.labels.template;

  if (labelTpl.fill) {
    range.label.fill = labelTpl.fill;
  }
  range.label.fontSize = labelTpl.fontSize;
  range.label.inside = false;

  range.axisFill.fillOpacity = 0;

  return range;
}

/**
 * Forces exact minimum and maximum labels and grid lines on a ValueAxis.
 * @param {Object} yAxis - amCharts ValueAxis instance
 * @param {Object} chartSettings - Component configuration containing yAxisMinValue and yAxisMaxValue
 */
// eslint-disable-next-line import/prefer-default-export
export const chartAxisBoundaries = (yAxis, chartSettings) => {
  const forcedMin = chartSettings.yAxisMinValue;
  const forcedMax = chartSettings.yAxisMaxValue;

  if (
    typeof forcedMin !== 'number'
    || typeof forcedMax !== 'number'
    || forcedMin >= forcedMax
  ) {
    return;
  }

  // Hide auto-labels near edges to avoid collision with boundary labels
  yAxis.renderer.minLabelPosition = LABEL_EDGE_THRESHOLD;
  yAxis.renderer.maxLabelPosition = 1 - LABEL_EDGE_THRESHOLD;

  const minRange = createBoundaryRange(yAxis, forcedMin);
  const maxRange = createBoundaryRange(yAxis, forcedMax);

  // Force boundary labels to render at the true axis edges (0 and 1)
  minRange.minPosition = 0;
  minRange.maxPosition = 1;
  maxRange.minPosition = 0;
  maxRange.maxPosition = 1;

  const syncRanges = () => {
    minRange.value = forcedMin;
    minRange.label.text = String(forcedMin);

    maxRange.value = forcedMax;
    maxRange.label.text = String(forcedMax);
  };

  yAxis.events.on('extremeschanged', syncRanges);
  yAxis.events.on('startendchanged', syncRanges);
};
